import { useListBoxSection } from '@react-aria/listbox';
import { useSeparator } from '@react-aria/separator';
import { ComboBoxState } from '@react-stately/combobox';
import type { Node } from '@react-types/shared';

import { fontStyles } from '@/styles/typography';

import { Option } from '../Option';

interface Props {
  section: Node<object>;
  state: ComboBoxState<object>;
}

export function ListBoxSection({ section, state }: Props) {
  const { itemProps, headingProps, groupProps } = useListBoxSection({
    'heading': section.rendered,
    'aria-label': section['aria-label'],
  });

  const { separatorProps } = useSeparator({
    elementType: 'li',
  });

  // If the section is not the first, add a separator element.
  // The heading is rendered inside an <li> element, which contains
  // a <ul> with the child items.
  return (
    <>
      {section.key !== state.collection.getFirstKey() && <li {...separatorProps} />}
      <li {...itemProps}>
        {section.rendered && (
          <div
            {...headingProps}
            className={fontStyles({
              variant: 'BODY_SM',
              class: 'text-token-gray-800 h-8 flex items-center px-2',
            })}
          >
            {section.rendered}
          </div>
        )}
        <ul {...groupProps}>
          {[...section.childNodes].map((node) => (
            <Option key={node.key} item={node} state={state} />
          ))}
        </ul>
      </li>
    </>
  );
}
